import { SET_DETAIL_NEWS } from "../actions/action-types.js";

export default function detailNews(state = {item: [], others: []}, {type, payload}) {
    switch (type) {
        case SET_DETAIL_NEWS:
            return (state = {...state, item: payload.item, others: payload.others})
        default:
            return state
    }
}